import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "cmdPlayList"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeListTitle = _resolveComponent("HomeListTitle");

  var _component_PlayList = _resolveComponent("PlayList");

  return _ctx.commendList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 推荐歌单 "), _createVNode(_component_HomeListTitle, {
    title: "推荐歌单",
    routerPath: "/main/playlist"
  }), _createCommentVNode(" 歌单列表区域 "), _createVNode(_component_PlayList, {
    playList: _ctx.commendList
  }, null, 8
  /* PROPS */
  , ["playList"])])) : _createCommentVNode("v-if", true);
}